import React, { createContext, useContext, useState } from "react";

const AIMSContext = createContext();
export const useAIMSContext = () => useContext(AIMSContext);

function AIMSContextProvider({ children }) {
  const queryParams = new URLSearchParams(window.location.search);
  const id = queryParams.get("aimsId") || "";

  const [AIMSPlantId, setAIMSPlantId] = useState(id);
  console.log("current aims id", AIMSPlantId);
  return (
    <AIMSContext.Provider value={{ AIMSPlantId, setAIMSPlantId }}>
      {children}
    </AIMSContext.Provider>
  );
}

export { AIMSContextProvider, AIMSContext };
